import React from 'react';

import {useTranslation} from 'react-i18next';
import {matchPath, Redirect, Route, Switch, useLocation} from 'react-router-dom';

import {PageHeader} from '@/widgets/PageHeader';
import {Period} from '@/widgets/Period';
import {ROUTES} from '@app/routing';
import {TaxpayerDetailsPage} from '@pages/TaxpayerDetails';
import {Page} from '@shared/ui/Page';
import {RouterTab, RouterTabList} from '@shared/ui/RouterTabs';

import {TabsContentCard, Wrapper} from './styled';
import {AuditJobsTab} from './ui/JobsTab';
import {AuditStatisticsTab} from './ui/StatisticsTab';
import {ViolationDetailsPage} from './ui/ViolationDetailsPage';
import {AuditViolationsTab} from './ui/ViolationsTab';

export const AuditPage = () => {
    const {t} = useTranslation();
    const {pathname} = useLocation();
    const isTaxpayerDetailsPage = Boolean(
        matchPath(pathname, {path: ROUTES.AUDIT_VIOLATIONS_TAXPAYER_DETAILS}),
    );

    return (
        <Page title={t('page_audit.title')}>
            <Wrapper>
                <PageHeader title={t('page_audit.title')}>
                    <Period requireMonth={isTaxpayerDetailsPage} />
                </PageHeader>

                <TabsContentCard>
                    <RouterTabList baseUrl={ROUTES.AUDIT}>
                        <RouterTab url="statistics">{t('menu.statistics')}</RouterTab>
                        <RouterTab
                            url="violations"
                            forceActive={pathname.startsWith(ROUTES.AUDIT_VIOLATIONS)}
                        >
                            {t('menu.register-of-violations')}
                        </RouterTab>
                        <RouterTab url="jobs">{t('menu.job-management')}</RouterTab>
                    </RouterTabList>
                </TabsContentCard>

                <Switch>
                    <Route path={ROUTES.AUDIT} exact>
                        <Redirect to={ROUTES.AUDIT_STATISTICS} />
                    </Route>
                    <Route path={ROUTES.AUDIT_STATISTICS} exact>
                        <AuditStatisticsTab />
                    </Route>
                    <Route path={ROUTES.AUDIT_VIOLATIONS} exact>
                        <AuditViolationsTab />
                    </Route>
                    <Route path={ROUTES.AUDIT_VIOLATIONS_TAXPAYER_DETAILS}>
                        <TaxpayerDetailsPage
                            basePath={ROUTES.AUDIT_VIOLATIONS_TAXPAYER_DETAILS}
                            backTo={ROUTES.AUDIT_VIOLATIONS}
                            hidePageHeader
                        />
                    </Route>
                    <Route path={ROUTES.AUDIT_VIOLATION_DETAILS} exact>
                        <Redirect
                            to={ROUTES.AUDIT_VIOLATION_GENERAL_INFORMATION.replace(
                                ':id',
                                pathname.split('/').pop() ?? '',
                            )}
                        />
                    </Route>
                    <Route
                        path={[
                            ROUTES.AUDIT_VIOLATION_GENERAL_INFORMATION,
                            ROUTES.AUDIT_VIOLATION_NOTIFICATIONS,
                            ROUTES.AUDIT_VIOLATION_HISTORY,
                        ]}
                    >
                        <ViolationDetailsPage />
                    </Route>
                    <Route path={ROUTES.AUDIT_JOBS} exact>
                        <AuditJobsTab />
                    </Route>
                    <Route path="*">
                        <Redirect to={ROUTES.AUDIT_STATISTICS} />
                    </Route>
                </Switch>
            </Wrapper>
        </Page>
    );
};
